// extracted by mini-css-extract-plugin
export var boxItems = "_1z-1";
export var boxItemsLg = "_1z-2";
export var button = "_1z-7";
export var buttonHoverless = "_1z-9";
export var buttonLg = "_1z-8";
export var filterGroupBox = "_1z-0";
export var icon = "_1z-3";
export var iconSecondary = "_1z-6";
export var iconWrapper = "_1z-4";
export var iconWrapperLg = "_1z-5";
export var truncatedLabel = "_1z-a";